import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';

const StyledXframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  
  ${ComponentStyles}
`;

StyledXframe.propTypes = {
};

export default StyledXframe;
